/* eslint-disable react/jsx-boolean-value,react/default-props-match-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';

import './form_radio_toggle.scss';

const CLASSNAME = 'form-control-radio-toggle';

const FormRadioToggle = ({
  className,
  classNameContainer,
  disabled,
  disabledUnselected,
  fieldProps,
  id,
  input,
  inputs,
  inputWrapperClassName,
  label,
  labelClassName,
  name,
  required,
  updateValue,
  onClick,
  value,
}) => (
  <div
    className={classnames(classNameContainer, `${CLASSNAME} d-flex flex-row`, {
      [`${CLASSNAME}--disabled`]: disabled,
      [`${CLASSNAME}--disabled-unselected`]: disabledUnselected,
    })}
  >
    {label && (
      <label
        htmlFor={id}
        className={classnames(labelClassName, `${CLASSNAME}__form-label d-flex flex-row`)}
      >
        {required ? (
          <span>
            {label} <span className={`${CLASSNAME}__error-text`}>*</span>
          </span>
        ) : (
          label
        )}
      </label>
    )}

    <div className={classnames(inputWrapperClassName, `${CLASSNAME}__input-wrapper d-flex`)}>
      {_.map(inputs, (radioInput, index) => (
        <div
          key={`${name}_${radioInput.value}`}
          className={classnames(`${CLASSNAME}__toggle`, {
            [`${CLASSNAME}__toggle--selected`]: value === radioInput.value,
            [`${CLASSNAME}__toggle--unselected`]: value !== radioInput.value,
          })}
        >
          <input
            checked={value === radioInput.value}
            className={classnames(className, `${CLASSNAME}__input`)}
            disabled={disabled || disabledUnselected}
            id={`${name}-${index}`}
            name={name}
            onChange={() => updateValue(radioInput.value)}
            onClick={onClick}
            type="radio"
            value={radioInput.value}
            {...fieldProps}
            {...input}
          />
          <label
            className={`${CLASSNAME}__label align-items-center d-flex`}
            htmlFor={`${name}-${index}`}
          >
            <span className={`${CLASSNAME}__label-circle`} />
            {radioInput.label}
          </label>
        </div>
      ))}
    </div>
  </div>
);

FormRadioToggle.propTypes = {
  className: PropTypes.string,
  classNameContainer: PropTypes.string,
  disabled: PropTypes.bool,
  disabledUnselected: PropTypes.bool,
  fieldProps: PropTypes.shape({}),
  id: PropTypes.string,
  input: PropTypes.shape({}),
  inputWrapperClassName: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelClassName: PropTypes.string,
  required: PropTypes.bool,
  inputs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
    }),
  ).isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  updateValue: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
};

FormRadioToggle.defaultProps = {
  className: '',
  disabled: false,
  disabledUnselected: false,
  fieldProps: {},
  onClick: () => {},
  required: false,
  updateValue: () => {},
  value: '',
};

export default FormRadioToggle;
